import React from "react";
import { IPackageItem } from "../PackageSelector.types";
import SharedStyles from "../../../../shared/styles/ItemRenderer.styles";
import { Badge, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBoxOpen,
  faChevronRight,
  faCaretUp,
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import CardUtils from "../../Card.utils";
import THEME from "../../../../theme/index";

import { isMobile } from "react-device-detect";

const PACKAGE_ITEM: React.FC<IPackageItem> = (props: IPackageItem) => {
  const { packageItem, selected, isPopOutItem, onClick } = props;
  const disabled = props.disabled ?? false;
  const defaultClassName = "package-list-item";
  const classes: string[] = [defaultClassName];
  // istanbul ignore next
  if (selected) {
    classes.push("selected");
  }

  // istanbul ignore next
  if (disabled) {
    classes.push("disabled-package");
  }

  const className: string = classes.reduce((x, y) => x + " " + y);

  return (
    <SharedStyles.PackageListItem className={className} onClick={onClick}>
      <Stack
        direction="horizontal"
        gap={2}
        className={
          /* istanbul ignore next */ disabled ? "disabled-package" : undefined
        }
      >
        <div>
          <FontAwesomeIcon
            className="package-icon"
            icon={faBoxOpen}
            color={THEME.CE_THEME.colors.grays.septenary}
          />
        </div>
        <Stack gap={0}>
          <span className="package-list-item-label">
            {packageItem?.packageName?.toUpperCase()}
          </span>
          <span className="package-list-item-sublabel">
            {packageItem?.phase?.name}
          </span>
        </Stack>

        {isPopOutItem && (
          <div className="popout-badge-container ms-auto">
            <Stack direction="horizontal" gap={2}>
              <Badge
                bg={
                  CardUtils.getBadgeFormat(
                    packageItem?.status?.name?.toUpperCase() ?? ""
                  ).colorFlag
                }
              >
                {
                  CardUtils.getBadgeFormat(
                    packageItem?.status?.name?.toUpperCase() ?? ""
                  ).label
                }
              </Badge>
              {
                /* istanbul ignore next */ !disabled ? (
                  <Stack gap={0}>
                    <FontAwesomeIcon className="up-caret" icon={faCaretUp} />
                    <FontAwesomeIcon
                      className="down-caret"
                      icon={faCaretDown}
                    />
                  </Stack>
                ) : null
              }
            </Stack>
          </div>
        )}
        {!isPopOutItem && (
          <div
            className={/* istanbul ignore next */ !isMobile ? "ms-auto" : ""}
          >
            <Stack direction="horizontal" gap={2}>
              <Badge
                bg={
                  CardUtils.getBadgeFormat(
                    packageItem?.status?.name?.toUpperCase() ?? ""
                  ).colorFlag
                }
              >
                {
                  CardUtils.getBadgeFormat(
                    packageItem?.status?.name?.toUpperCase() ?? ""
                  ).label
                }
              </Badge>
              {
                /* istanbul ignore next */ !disabled ? (
                  <FontAwesomeIcon
                    className="chevron-style"
                    icon={faChevronRight}
                  />
                ) : null
              }
            </Stack>
          </div>
        )}
      </Stack>
    </SharedStyles.PackageListItem>
  );
};

export default PACKAGE_ITEM;
